import type { XYChartXAxisProps } from '../types/xy-chart-props.js';

export const XAxis = (props: XYChartXAxisProps) => null;

XAxis['displayName'] = 'XYChart.XAxis';
